import {
    GET_OMS_REPORT_DATA_ERROR,
    GET_OMS_REPORT_DATA_REQUEST,
    GET_OMS_REPORT_DATA_SUCCESS,
} from "../actions/types";
import { BASEURL } from "../../constant/config.js";
import moment from "moment";

const axios = require("axios");
export const getOmsReport = (token, data) => (dispatch) => {

    dispatch({ type: GET_OMS_REPORT_DATA_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}getAll/getSaleOrderGroupReport`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: {
            from_date: moment(data.from_date).format("MM-DD-YYYY"),
            to_date: moment(data.to_date).format("MM-DD-YYYY"),
            gender_id: data.gender_id === "All" ? null : data.gender_id,
            date_type: data.date_type,
            customer_type_id: data.customer_type_id === "All" ? null : data.customer_type_id,
            region_id: data.region_id === "All" ? null : data.region_id,
            // region_id: data.region_id && data.region_id !== "All" ? data.region_id.toString() : null,
            company_id: data.company_id
        }
    })
        .then((response) => {
            return dispatch({ type: GET_OMS_REPORT_DATA_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            if (error.response.data.data === "No Record Found !") {
                return dispatch({
                    type: GET_OMS_REPORT_DATA_ERROR,
                    payload: [],
                });
            }
            return dispatch({
                type: GET_OMS_REPORT_DATA_ERROR,
                payload: error.response,
            });
        });
};
